import axios from '@/plugins/axios'

export default {
  async GET_INFORMATION ({ commit, state }) {
    return new Promise((resolve, reject) => {
      const data = {
        headers: {
          Authorization: 'Bearer ' + state.access_token
        }
      }
      commit('loading')
      axios.get('profile', data).then((response) => {
        commit('loadingFail')
        resolve(response)
      }).catch(error => {
        commit('loadingFail')
        reject(error)
      })
    })
  },
  async UPDATE_GTAG ({ commit, state }, payload) {
    return new Promise((resolve, reject) => {
      const data = {
        headers: {
          Authorization: 'Bearer ' + state.access_token
        }
      }
      commit('loading')
      axios.put('profile/gtag', payload, data).then((response) => {
        commit('loadingFail')
        resolve(response)
      }).catch(error => {
        commit('loadingFail')
        reject(error)
      })
    })
  },
  async UPDATE_PIXEL ({ commit, state }, payload) {
    return new Promise((resolve, reject) => {
      const data = {
        headers: {
          Authorization: 'Bearer ' + state.access_token
        }
      }
      commit('loading')
      axios.put('profile/pixel', payload, data).then((response) => {
        commit('loadingFail')
        resolve(response)
      }).catch(error => {
        commit('loadingFail')
        reject(error)
      })
    })
  },
  async UPDATE_PASSWORD ({ commit, state }, payload) {
    return new Promise((resolve, reject) => {
      const data = {
        headers: {
          Authorization: 'Bearer ' + state.access_token
        }
      }
      commit('loading')
      axios.put('profile/password', payload, data).then((response) => {
        commit('loadingFail')
        resolve(response)
      }).catch(error => {
        commit('loadingFail')
        reject(error)
      })
    })
  },
  async UPDATE_PROFILE ({ commit, state }, payload) {
    return new Promise((resolve, reject) => {
      const data = {
        headers: {
          Authorization: 'Bearer ' + state.access_token
        }
      }
      commit('loading')
      axios.put('profile', payload, data).then((response) => {
        commit('loadingFail')
        resolve(response)
      }).catch(error => {
        commit('loadingFail')
        reject(error)
      })
    })
  }
}
